import { ISendSignature, Info, SendSignatureDTO } from './../core/interfaces/digital-signature-send';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalSignatureController } from '../core/controllers/digital-signature.controller';
import { environment } from 'src/environments/environment';
import { PrefixState } from '../core/classes/prefix-state';
import { HttpClient } from '@angular/common/http';
import { CheckTokenReturn } from '../core/interfaces/check-token-return';
import { SignatureStorageService } from '../core/lib/signature-storage.service';
import { CompanyUiCustomizationService } from '../core/lib/company-ui/company.ui-customization.service';
import { CompanyUiSettings } from '../core/lib/company-ui/company.ui-settings';

@Component({
  selector: 'app-digital-signature',
  templateUrl: './digital-signature.component.html',
  styleUrls: ['./digital-signature.component.scss']
})
export class DigitalSignatureComponent implements OnInit {
  signatureForm: FormGroup;

  PrefixJsonPath: string = "/assets/json/prefix.json";

  yousign: any;
  showFrame = false;
  iFrame = false;
  finish = false;
  token: string = '';
  fileUrl: string = "";
  tokenValid: boolean | null = true;  // Stato del token
  message: string | null = null; // Messaggio di errore
  urlYouSign: string | null = null; // Url  

  // ── Branding dinamico ────────────────────────────────────────────────────────
  // Logo del brand letto da environment, usato come fallback quando la company
  // non ha un logo specifico o quando CompanyCode non è valorizzato.
  readonly brandLogoSrc: string = environment.brand.theme.extendedLogo;

  // Logo specifico della company risolto in base al CompanyCode restituito da
  // checkToken(): null finché non viene caricato per evitare img con src vuoto.
  companyLogoSrc: string | null = null;

  // Label dinamica del file da firmare (sostituisce il nome hardcoded).
  labelFileName: string = "";

  // CompanyCode ricevuto da checkToken(): propagato come queryParam alla thank-you
  // page per permetterle di risolvere il logo dinamicamente.
  private companyCode: string = "";

  countryPrefixes : PrefixState[] | undefined = [];

    constructor(
      private fb: FormBuilder, 
      private route: Router, 
      private activatedRoute: ActivatedRoute, 
      private digitalSignatureController: DigitalSignatureController,
      private http: HttpClient,
      private signatureStorageService: SignatureStorageService,
      private companyUiCustomizationService: CompanyUiCustomizationService
    ) {
    this.signatureForm = this.fb.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      prefix: ['+39', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    });


  }

  async ngOnInit(): Promise<void> {
    
    this.activatedRoute.queryParams.subscribe(async params => {
      if (params['token']) {
        this.token = params['token'];
        
        // Controllo immediato se il token è già stato firmato
        if (this.signatureStorageService.isTokenAlreadySigned(this.token)) {
          // Token già firmato, redirect immediato alla thank you page
          this.route.navigate(['/digital-signature/thank-you']);
          return;
        }
        
        this.fileUrl = `${environment.projectConfiguration.API_URL}/DocumentSign/GetFileByToken?token=${this.token}`
      }
    });

    this.countryPrefixes = await this.http.get<PrefixState[]>(this.PrefixJsonPath).toPromise();

  }

  async ngAfterViewInit(): Promise<void> {
    const checkTokenReturn = await this.checkToken();

    this.tokenValid = checkTokenReturn.isValid;
    this.message = checkTokenReturn.ErrorMessage || "Documento non valido o scaduto.";
    this.urlYouSign = checkTokenReturn.Url || null;
    this.labelFileName = checkTokenReturn.LabelFileName || "";
    this.companyCode = checkTokenReturn.CompanyCode || "";

    // Carico il logo della company in base al CompanyCode restituito dal backend.
    await this.loadCompanyBranding(checkTokenReturn.CompanyCode);

  }

  /**
   * Risolve il logo da mostrare in base al CompanyCode ricevuto da checkToken().
   * Se il code è vuoto o la company non ha un logo specifico, ricade sul logo
   * di brand definito in environment.
   */
  private async loadCompanyBranding(companyCode: string): Promise<void> {

    if (!companyCode) {

      this.companyLogoSrc = this.brandLogoSrc;
      return;

    }

    const company = await this.companyUiCustomizationService.getSettings(companyCode);
    const logo = await (company ?? new CompanyUiSettings(companyCode)).getLogo();

    this.companyLogoSrc = logo.default ? this.brandLogoSrc : logo.src;

  }

  showIFrameByUrl(){

    if(this.urlYouSign)
    {

      this.showFrame = true;

      setTimeout(() => {
        this.yousign = new Yousign({
          signatureLink: this.urlYouSign,
          iframeContainerId: 'iframe-container',
          isSandbox: environment.production == false, //To set if you use the sandbox environment
        });
      
        this.yousign.onSignatureDone((data: any) => {
          // Salvo nel localStorage che il token è stato firmato con successo
          this.signatureStorageService.saveSignatureData(this.token, true);
          
          setTimeout(() => {
            this.finish = true;
            // Propago il companyCode alla thank-you per il logo dinamico.
            this.route.navigate(['/digital-signature/thank-you'], { queryParams: { company: this.companyCode } });
            if (this.iFrame) {
              this.showFrame = false;
            }
          }, 15000);
        });
  
        
        const THIS = this;

        window.addEventListener('message', function(e) {
          // Check if the origin of the message is really come from Yousign
          if(e.origin === 'https://yousign.app' && e.data.type === 'yousign'){
            if(e.data.event === 'declined'){ THIS.getErrorEvent(); }
            if(e.data.event === 'error'){ THIS.getErrorEvent(); }
          }
        });

      }, 1000);



      this.iFrame = true;

    }

  }

  viewContract() {
    // Inserire link
    window.open('/', '_blank');
  }

  onSubmit() {

    const sendSignatureDTO = this.getSendSignatureDTO();
    if (sendSignatureDTO == null) return;

    this.digitalSignatureController.activateSignature(sendSignatureDTO).then((data) => {
      if(data?.signers?.length == undefined || data?.signers?.length == null || data?.signers?.length <= 0){
        this.getErrorEvent();
        return;
      }

      if(data?.signers[0] === undefined || data?.signers[0] === null) {
        this.getErrorEvent();
        return;
      }
        
      this.showFrame = true;

      

      setTimeout(() => {
        this.yousign = new Yousign({
          signatureLink: data?.signers[0].signature_link,
          iframeContainerId: 'iframe-container',
          isSandbox: environment.production == false, //To set if you use the sandbox environment
        });
      
        this.yousign.onSignatureDone((data: any) => {
          // Salvo nel localStorage che il token è stato firmato con successo
          this.signatureStorageService.saveSignatureData(this.token, true);
          
          setTimeout(() => {
            this.finish = true;
            // Propago il companyCode alla thank-you per il logo dinamico.
            this.route.navigate(['/digital-signature/thank-you'], { queryParams: { company: this.companyCode } });
            if (this.iFrame) {
              this.showFrame = false;
            }
          }, 15000);
        });
  
        
        const THIS = this;

        window.addEventListener('message', function(e) {
          // Check if the origin of the message is really come from Yousign
          if(e.origin === 'https://yousign.app' && e.data.type === 'yousign'){
            if(e.data.event === 'declined'){ THIS.getErrorEvent(); }
            if(e.data.event === 'error'){ THIS.getErrorEvent(); }
          }
        });

      }, 1000);



      this.iFrame = true;
    }).catch((error) => {
      console.log(error);
    });

  
  }

  disableIframe() {

    if (this.finish)
      this.route.navigate(['/digital-signature/thank-you'], { queryParams: { company: this.companyCode } });
  }

  private getSendSignatureDTO(): SendSignatureDTO | null {
    if (!this.signatureForm.valid) return null;

    const phone_number = this.signatureForm.get('prefix')?.value + this.signatureForm.get('phone')?.value;

    const sendSignature: ISendSignature = {
      SignerInfo: new Info({
        first_name: this.signatureForm.get('name')?.value,
        last_name: this.signatureForm.get('surname')?.value,
        phone_number : phone_number,
      }),
      Token: this.token
    }

    return new SendSignatureDTO().create(sendSignature);
  }

  private getErrorEvent(message: string = '') {
    setTimeout(() => {
      // Propago il companyCode alla error-message per il logo dinamico.
      // Uso window.location.href (al posto del Router) per mantenere il comportamento esistente.
      const companyParam = this.companyCode ? `?company=${encodeURIComponent(this.companyCode)}` : '';
      window.location.href = `/digital-signature/error-message${companyParam}`;
    }, 1000);
  }

  async checkToken(): Promise<CheckTokenReturn> {
    
    if (!this.token) return new CheckTokenReturn(false, "Nessun token trovato");

    const sendSignature: ISendSignature = {
      SignerInfo: new Info({
        first_name: '',
        last_name: '',
        phone_number : '',
      }),
      Token: this.token
    }

    return await this.digitalSignatureController.checkToken(sendSignature);
  }
}
